export const siteShape: {
  /** The 248px left rail on signed-in pages. Off: the masthead carries brandmark / coworld switcher, search and the account menu instead. */
  readonly signedInRail: boolean;
  /** Game documentation, Forum and Browse doors in the signed-in masthead and drawer. */
  readonly navDoors: boolean;
  /** League rows in the coworld switcher. */
  readonly leagueSwitching: boolean;
} = {
  signedInRail: false,
  navDoors: false,
  leagueSwitching: false,
};

// Editorial tile order, keyed by corpus identity.
export const featuredCoworlds: readonly string[] = [
  "generals-competition",
  "gods-of-the-arena",
  "sugarscape-2",
];
